// 本期综合考评报告
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="综合考评报告"
    top="5%"
    width="50%"
    :center="true"
    :before-close="doClose"
  >
    <div class="archives_box">
      <div class="df" style="justify-content: flex-end; margin-bottom: 10px">
        <el-button
          class="bgc-bv"
          style="margin: 0 10px"
          size="mini"
          @click="handlUpdate()"
          >更新数据</el-button
        >
        <el-button
          class="bgc-bv"
          style="margin: 0 10px"
          size="mini"
          @click="doDownLoad()"
          >下载</el-button
        >
      </div>
      <div id="pdf-content2" style="height: 600px"></div>
    </div>
  </el-dialog>
</template>

<script>
import pdf from "pdfobject";
export default {
  name: "AssessmentReport",
  props: [],
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    showPop(res) {
      this.playload = JSON.parse(res);
      this.queryData();
    },
    queryData() {
      let params = {
        enterpriseId: this.playload.enterpriseId,
        phaseId: this.playload.phaseId,
      };
      this.$post("/biz/dm/trainComprehensiveAssessment/download", params)
        .then((res) => {
          if (res.status == "0") {
            // ;
            this.dialogVisible = true;
            this.$nextTick(() => {
              pdf.embed(res.data.url, "#pdf-content2", {
                pdfOpenParams: {
                  scrollbars: "0",
                  toolbar: "0",
                  statusbar: "1",
                },
              });
            });
          }
        })
        .catch(() => {
          this.dialogVisible = false;
        });
    },
    handlUpdate() {
      let params = {
        enterpriseId: this.playload.enterpriseId,
        phaseId: this.playload.phaseId,
      };
      this.$post("/biz/dm/trainComprehensiveAssessment/update", params)
        .then((res) => {
          if (res.status == "0") {
            this.$nextTick(() => {
              pdf.embed(res.data.url, "#pdf-content2");
            });
          }
        })
        .catch(() => {});
    },
    doDownLoad() {
      this.$post("/biz/dm/trainComprehensiveAssessment/download", {
        enterpriseId: this.playload.enterpriseId,
        phaseId: this.playload.phaseId,
      }).then((res) => {
        // ;
        if (res.status == "0") {
          let url = res.data.download_url || "";
          window.open(url);
        }
      });
    },
    doClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style>
</style>